module.exports = __webpack_public_path__ + "img/logo.35e3a1a7.png";